export default "__VITE_ASSET__58dec698__"